import { useMemo } from 'react';
import { useSprints } from '@/hooks/use-sprints';
import { SearchableSelect } from '@/components/ui/searchable-select';

const ACTIVE = 'active';

export function SprintPicker({
  boardId,
  value,
  onChange,
}: {
  boardId: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const { data: sprints = [] } = useSprints(boardId);
  const options = useMemo(
    () => [
      { id: ACTIVE, name: 'Active sprint' },
      ...sprints.map((s) => ({ id: s.id, name: s.name })),
    ],
    [sprints]
  );
  return (
    <SearchableSelect
      value={value || ACTIVE}
      onChange={(v) => onChange(v || ACTIVE)}
      options={options}
      placeholder="Pick a sprint…"
      allowNone={false}
      ariaLabel="Sprint"
    />
  );
}
